import React from "react";

export const Features = (props) => {
  const data = props.data;
  return (
    <div id="features" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>{data ? data.title : "Core Expertise"}</h2>
          <p>{data ? data.subtitle : ""}</p>
        </div>
        <div className="row">
          {data && data.items
            ? data.items.map((d, i) => (
                <div key={`${d.title}-${i}`} className="col-xs-6 col-md-3">
                  <div className="feature-card">
                    <i className={d.icon}></i>
                    <h3>{d.title}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};
